<template lang="pug">
  span
    DataProvider(:endpoint='endpoint', :filter='filter', ref='dataProvider' :key="componentKey")
      div(slot-scope='{ data: response, error, loading }')
        DataTable(
          ref='dataTable'
          :title="$t('operatorsJourney.operatorList')"
          :customTotal='(response && response.total) || 0'
          :selectable='false'
          @pagination='handlePagination'
          v-if='response && response.data'
          :data='response && response.data'
          :loading='loading'
          customHeader
          :endpoint='endpoint'
          :filter='filter'
          :labels='labels'
          :formatLabelFunction='formatLabels'
          :createHeader='createHeaderPDF'
          :fileName="$t('operatorsJourney.fileName')"
        )
          template(slot='title-left')
            v-row(no-gutters
            class="mobile"
            style='float: right; margin-top: 15px;')
              v-col
                v-text-field(
                  v-model='search'
                  v-on:keyup.enter='searchUpdate()'
                  append-icon="mdi-account-search"
                  @click:append='searchUpdate()'
                  :label="$t('operatorsJourney.search')"
                )
              v-col(cols='auto')
                v-menu(v-model='showFilter' :close-on-content-click='false' transition='scale-transition' offset-y max-width='290px' min-width='290px')
                  template(v-slot:activator='{ on, attrs }')
                    md-button(@click='toggleShowFilter()' md-menu-trigger class='md-simple md-github' v-bind='attrs' v-on='on')
                      v-icon(style='position: absolute; left: -5px;') mdi-calendar
                      div(style='margin:  8px 0 8px 33px;') {{$t('operatorsJourney.changeDate')}}
                  v-date-picker(v-model='selectedDate' @input='showFilter = false' @change='updatedDate' locale='pt-BR' color='#9c27b0')
          template(slot='cells'  slot-scope='{ item }')
            md-table-cell(:md-label='labels[0]') {{formatLabels(item, 0)}}
            md-table-cell(:md-label='labels[1]') {{formatLabels(item, 1)}}
            md-table-cell(:md-label='labels[2]') {{formatLabels(item, 2)}}
            md-table-cell(:md-label='labels[3]') {{formatLabels(item, 3)}}
            md-table-cell(:md-label='labels[4]') {{formatLabels(item, 4)}}
            md-table-cell(md-label='Eventos')
              v-row(no-gutters style='justify-content: flex-end;')
                v-col(cols='auto' style='padding: 4px; margin: 8px 0;')
                  v-btn(
                    class="mx-2"
                    small
                    rounded
                    dark
                    color="#9c27b0"
                    @click='openDialog(item)'
                  )
                    | {{$t('operatorsJourney.toSee')}}
                  md-tooltip(md-direction="bottom")
                    | {{$t('operatorsJourney.viewOperator')}}
          template(slot='footer' slot-scope='{ pagination }')
            v-row(style='justify-content: flex-end;')
              v-col(cols='auto')
                md-field
                  label(for='pages') {{ $t('assistantsList.perPage') }}
                  md-select(v-model='pagination.perPage' name='pages' )
                    md-option(
                      v-for='item in pagination.perPageOptions',
                      :key='item',
                      :label='item',
                      :value='item')
                      | {{ item }}
        v-dialog(v-model='dialog' scrollable)
          OperatorTimeline(
            :item='item'
            :operatorTimelineInfo='operatorTimelineInfo'
            :date='timestamp1'
            :timelineLoader='timelineLoader'
            @close='closeDialog'
            )

</template>

<script>
import Pagination from '@/components/Pagination.vue'
import DataProvider from '@/components/DataProvider'
import DataTable from '@/components/DataTable.vue'
import OperatorTimeline from '@/pages/OperatorTimeline'
import { selectedLocale } from '@/plugins/i18n'
import moment from 'moment'

export default {
  components: {
    Pagination,
    DataTable,
    OperatorTimeline,
    DataProvider
  },
  data () {
    return {
      labels: ['Login', 'Email', this.$t('operatorsJourney.operator'), this.$t('operatorsJourney.lastLogin'), this.$t('operatorsJourney.lastLogout')],
      componentKey: 0,
      showFilter: false,
      timestamp1: null,
      dialog: false,
      search: '',
      timelineLoader: false,
      operatorTimelineInfo: {},
      item: {},
      method: '',
      selectedDate: '',
      filter: {
        page: 0,
        perPage: 5
      }
    }
  },
  computed: {
    endpoint () {
      return `${process.env.VUE_APP_REPORTS_BACKEND}/operators`
    }
  },
  created () {
    this.timestamp1 = moment().startOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
    this.selectedDate = this.timestamp1.split('T')[0]
    this.filter.from = this.timestamp1
    this.filter.to = this.nextDay(this.timestamp1)
  },
  watch: {
    selectedDate: {
      handler (nv) {
        this.timestamp1 = moment(nv).startOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
        this.updatedDate()
      }
    }
  },
  methods: {
    forceRerender () {
      this.componentKey += 1
    },
    updatedDate () {
      this.filter.from = this.timestamp1
      this.filter.to = this.nextDay(this.timestamp1)
      this.$refs.dataProvider.load()
    },
    searchUpdate () {
      this.filter.search = this.search
      this.$refs.dataProvider.load()
    },
    nextDay (date) {
      return moment(date).add(1, 'day').format('YYYY-MM-DD[T]HH:mm:ss')
    },
    handlePagination (pagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    async openDialog (item) {
      try {
        this.item = item
        this.dialog = true
        this.timelineLoader = true
        const result = await this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/operators/${item._id}/events`, {
          params: {
            from: this.timestamp1,
            to: this.nextDay(this.timestamp1)
          }
        })
        this.operatorTimelineInfo = result.data
        this.timelineLoader = false
      } catch (error) {
        // console.log(error)
      }
    },
    closeDialog () {
      this.dialog = false
    },
    toggleShowFilter () {
      this.showFilter = !this.showFilter
    },
    formatDate (date) {
      return moment(date).locale(selectedLocale).format('L LT')
    },
    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return item._source.login
        case 1:
          return item._source.email
        case 2:
          return item._source.fullName
        case 3:
          return item._source.lastLogonAt ? this.formatDate(item._source.lastLogonAt) : '-'
        case 4:
          return item._source.lastLogoffAt ? this.formatDate(item._source.lastLogoffAt) : '-'
        default:
          break
      }
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('drawer.operatorsJourney'))

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, 'Total: ')
      doc.setFont(undefined, undefined, '300')
      doc.text(25, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    }
  }
}
</script>

<style scoped>
  @media (max-width: 1160px) {
    .mobile {
    margin-top: 60px !important;
    margin-right: -300px !important;
    }
  }
</style>
